import { CATEGORY } from "../../../modules/constants"
import { formatIntDate_YYYY_MM_DD } from "../../../modules/utilities"
import { wouldExceedMaxCount } from "./homeFunctions"
import { fetchId } from "../../companiesHouse/pageFunctions/commonFunctions"

export const handleToggleLseFavourite = {
  company: props => {
    // This is what happens when the favourite icon of a LSE company row is toggled
    // Simpler than toggling search since only dealing with companies
    // console.log('handleToggleLseFavourite.company props:', props)
    const { advisersMeta, entities, favourites, lseCompaniesMeta, newsMeta, row, searchResults } = props
    // console.log(`handleToggleLseFavourite ${row.category} row: ${row.category}`)
    let thisState = {}

    const companyMeta = lseCompaniesMeta.items[row.index]
    // console.log('companyMeta:', companyMeta)

    let isFavourite = !row.isFavourite
    const companyNumber  = companyMeta.ids[0]

    if (row.isFavourite)
      // If is currently a favourite, then we delete the favourite
      props.fav.delete("company", companyNumber)
    else {
      // If not currently a favourite, then we add to favourites (conditional)
      companyMeta.category = CATEGORY.COMPANY
      if (wouldExceedMaxCount(companyMeta, favourites)) {
        thisState = { showMaxFavouritesReached: true } // NB: 'category' not used by MaxFavouritesReachedModal
        isFavourite = false
      }

      const entity = createDummyEntityFromCompanyMeta(companyMeta)
      favAdd({ ...props, entity })
    }

    // NB: We did do this via nexus function* but setIsFavouriteByIndex causes the refresh so we don't need to?
    const entity = getEntityViaCompanyNumber({ entities, companyNumber })
    if (!!entity)
      entity.isFavourite = isFavourite

    props.search.setIsFavouriteById({ searchResults, _id: companyNumber, isFavourite })

    // Toggle the corresponding lse item by row index
    props.lse.setIsFavouriteByIndex(lseCompaniesMeta, row.index, isFavourite)
    props.news.setFavouriteByCompanyNumber({ newsMeta, companyNumber, isFavourite })
    props.advisers.setIsFavouriteById(advisersMeta, companyNumber, isFavourite)

    // Set synced false to force sync of search results and favourites
    props.search.setSynced({ synced: false })

    return thisState
  },

  person: props => {
    // This is what happens when the favourite icon of a LSE person row is toggled
    const { entities, favourites, features, lsePeopleMeta, row } = props
    const item = lsePeopleMeta.items[row.index]
    const isFavourite = !row.isFavourite
    const _id = fetchId(item.commonInfo.officerIds)
    let thisState = {}
    if (row.isFavourite) {
      // If is currently a favourite, then we delete the favourite
      props.fav.delete(CATEGORY.PERSON, _id)
    }
    else {
      // If not currently a favourite, then we add to favourites (conditional)
      item.category = CATEGORY.PERSON
      if (!features.Developer && wouldExceedMaxCount(item, favourites))
        thisState = { showMaxFavouritesReached: true, category: CATEGORY.PERSON }
      else {
        const entity = createDummyEntityFromPersonMeta(item)
        favAdd({ ...props, entity })
      }
    }
    // Set synced false to force sync of search results and favourites
    props.search.setSynced({ synced: false })
    props.nexus.setEntityIsFavourite(entities, _id, isFavourite)
    // Toggle the corresponding lse item by row index
    props.lse.setIsFavouritePersonByIndex(lsePeopleMeta, row.index, isFavourite)

    return thisState
  },

  adviser: props => {
    // This is what happens when the favourite icon of an adviser row is toggled
    const { advisersMeta, entities, favourites, lseCompaniesMeta, newsMeta, row, searchResults } = props
    let thisState = {}
    let isFavourite = !row.isFavourite
    // Use CH company number as the favourite entity ID (consistent with company-page favourites).
    // Fall back to MongoDB _id only if no company number is available.
    const entityId = row.ids?.[0] || row._id

    if (row.isFavourite) {
      props.fav.delete(CATEGORY.COMPANY, entityId)
    } else {
      const entity = {
        _id: entityId,
        category: CATEGORY.COMPANY,
        ids: row.ids,
        name: {
          original: row.title,
          toMatch: row.title,
          toPresent: row.title,
          toSort: row.title,
        },
      }
      if (wouldExceedMaxCount(entity, favourites)) {
        thisState = { showMaxFavouritesReached: true }
        isFavourite = false
      } else {
        favAdd({ ...props, entity })
      }
    }

    props.advisers.setIsFavouriteById(advisersMeta, row._id, isFavourite)
    props.lse.setIsFavouriteById({ lseCompaniesMeta, _id: entityId, isFavourite })
    props.nexus.setEntityIsFavourite(entities, entityId, isFavourite)
    props.news.setFavouriteByCompanyNumber({ newsMeta, companyNumber: entityId, isFavourite })
    props.search.updateIsFavouriteUsingIds({ searchResults, ids: row.ids, isFavourite })
    props.search.setSynced({ synced: false })

    return thisState
  },

  news: props => {
    // This is what happens when the favourite icon of a LSE News row is toggled
    // console.log('handleToggleLseFavourite.news props:', props)
    const { advisersMeta, entities, favourites, lse, lseCompaniesMeta, newsMeta, row, searchResults } = props

    const item = newsMeta[row.index]
    const { lei, number: _id } = item

    let thisState = {}
    let isFavourite = !row.isFavourite

    // If is currently a favourite, then we delete the favourite
    if (row.isFavourite)
      props.fav.delete("company", _id)
    else {
      // If not currently a favourite, then we add to favourites (conditional)
      // if (!features.Developer && wouldExceedMaxCount(item, favourites)) {
      if (wouldExceedMaxCount(item, favourites)) {
        thisState = { showMaxFavouritesReached: true }
        isFavourite = false
      }

      const entity = createDummyEntityFromNewsMeta(item)

      favAdd({ ...props, entity })
    }

    // Update lseCompaniesMeta ie Lse Companies tab
    lse.setIsFavouriteById({ lseCompaniesMeta, _id, isFavourite })

    // Toggle entity isFavourite flag - if it exists
    // NB: We could do this via a nexus function* but setFavouriteByLei causes the refresh so we don't need to?
    toggleEntityIsFavourite({ entities, isFavourite, lei })

    // Toggle the corresponding news items by lei
    props.news.setFavouriteByLei({ newsMeta, isFavourite, lei })

    props.search.setIsFavouriteById({ searchResults, _id, isFavourite })
    props.advisers.setIsFavouriteById(advisersMeta, _id, isFavourite)

    // Set synced false to force sync of search results and favourites
    props.search.setSynced({ synced: false })

    return thisState
  },

  search: props => {
    // This is what happens when the favourite icon of a search row is toggled
    // console.log('handleToggleLseFavourite.search props:', props)

    const { advisersMeta, entities, fav, favourites, features, lse, lseCompaniesMeta, lsePeopleMeta, newsMeta, row, searchResults } = props
    const item = searchResults.items[row.index]
    const { _id, category, companyNumber } = item

    let isFavourite = !row.isFavourite
    let thisState = {}

    if (row.isFavourite) // If it is currently a favourite, then we delete the favourite
      fav.delete(item.category, _id)
    else // if not currently a favourite, then we add to favourites (conditional)
      if (!features.Developer && wouldExceedMaxCount(item, favourites)) {
        thisState = { showMaxFavouritesReached: true }
        isFavourite = false
      }
      else
        favAdd({ ...props, entity: item })

    props.search.setIsFavouriteByIndex(searchResults, row.index, isFavourite)
    updateLseMeta({ _id, category, isFavourite, lse, lseCompaniesMeta, lsePeopleMeta })
    props.nexus.setEntityIsFavourite(entities, _id, isFavourite)
    props.news.setFavouriteByCompanyNumber({ newsMeta, companyNumber, isFavourite })
    if (category === CATEGORY.COMPANY)
      props.advisers.setIsFavouriteById(advisersMeta, _id, isFavourite)

    return thisState
  },
}

const getEntityViaCompanyNumber = ({ entities, companyNumber }) => Object.values(entities.items).find(obj => obj.companyProps.number === companyNumber)

const toggleEntityIsFavourite = ({ entities, isFavourite, lei }) => {
  if (lei) {
    const entity = getEntityViaLei({ entities, lei })

    if (!!entity)
      entity.isFavourite = isFavourite
  }
}

const getEntityViaLei = ({ entities, lei }) => Object.values(entities.items).find(obj => obj.companyProps?.lse?.lei === lei)

// Revise the corresponding lse person or company (if any) favourite status
const updateLseMeta = ({ _id, category, isFavourite, lse, lseCompaniesMeta, lsePeopleMeta }) => {
  if (category === CATEGORY.COMPANY)
    lse.setIsFavouriteById({ lseCompaniesMeta, _id, isFavourite })
  else
    lse.setIsFavouritePersonById({ lsePeopleMeta, _id, isFavourite })
}

const favAdd = props => {
  const { entities, entity, fav, features } = props
  fav.add({ entity, entities, features })
}

const createDummyEntityFromCompanyMeta = companyMeta => {
  // console.log('companyMeta:', companyMeta)
  const name = {
    original: companyMeta.names[0],
    toMatch: companyMeta.names[0],
    toPresent: companyMeta.names[0],
    toSort: companyMeta.names[0],
  }

  const agmDates = {
    last: companyMeta.agmDates?.last > -1
      ? formatIntDate_YYYY_MM_DD(companyMeta.agmDates?.last)
      : null,
    next: null,
  }

  return {
    ...companyMeta,
    _id: companyMeta.ids[0],
    name,
    agmDates,
    address: {
      locality: companyMeta.locality,
    }
  }
}

const createDummyEntityFromPersonMeta = entity => {
  // console.log('createDummyEntityFromPersonMeta entity:', entity)
  return {
    _id: fetchId(entity.commonInfo.officerIds),
    ids: entity.commonInfo.officerIds,
    category: CATEGORY.PERSON,
    name: {
      toPresent: entity.commonInfo.name,
      toSort: entity.nameToSort,
    },
    personInfo: entity.personInfo
  }
}

const createDummyEntityFromNewsMeta = newsReleaseMeta => {
  // console.log('createDummyEntityFromNewsMeta newsReleaseMeta:', newsReleaseMeta)
  return {
    _id: newsReleaseMeta.lei,
    category: CATEGORY.COMPANY,
    ids: [newsReleaseMeta.number],
    name: {
      original: newsReleaseMeta.company,
      toMatch: newsReleaseMeta.company,
      toPresent: newsReleaseMeta.company,
      toSort: newsReleaseMeta.company,
    }
  }
}
